module.exports = __webpack_public_path__ + "img/phone.696f19ff.svg";